import {
	KeyboardDatePicker as MuiKeyboardDatePicker,
	KeyboardDatePickerProps as MuiKeyboardDatePickerProps,
} from '@material-ui/pickers/DatePicker';
import { Field, FieldMetaState, FieldRenderProps } from 'react-final-form';
import { SvgIcon } from '@material-ui/core';
import { getIconComponent } from 'lib/icon';

type DatePickerWrapperProps = FieldRenderProps<MuiKeyboardDatePickerProps>;

interface ShowErrorProps {
	meta: FieldMetaState<never>;
}

type ShowErrorFunc = (props: ShowErrorProps) => boolean;

const showErrorOnChange: ShowErrorFunc = ({
	meta: { submitError, dirtySinceLastSubmit, error, touched, modified },
}: ShowErrorProps) => Boolean(((submitError && !dirtySinceLastSubmit) || error) && (touched || modified));

function KeyboardDatePickerWrapper(props: DatePickerWrapperProps) {
	const {
		input: { name, onChange, value, ...restInput },
		meta,
		showError = showErrorOnChange,
		...rest
	} = props;

	const { error, submitError } = meta;
	const isError = showError({ meta });

	const { helperText, ...lessrest } = rest;
	const calendarPath = 'calendar';

	return (
		<MuiKeyboardDatePicker
			disableToolbar
			fullWidth
			variant={rest.variant ?? 'dialog'}
			autoOk
			helperText={isError ? error || submitError : helperText}
			error={isError}
			onChange={onChange}
			name={name}
			value={value || null}
			inputProps={restInput}
			{...lessrest}
			keyboardIcon={<SvgIcon component={getIconComponent(calendarPath)} viewBox="0 0 18 18" />}
		/>
	);
}

interface KeyboardDatePickerProps extends Partial<Omit<MuiKeyboardDatePickerProps, 'onChange'>> {
	name: string;
	fieldProps?: Record<string, unknown>;
	showError?: ShowErrorFunc;
	onChange?: (day: number | Date, value?: string | null) => void;
	variant?: 'dialog' | 'inline' | 'static';
}

function DateControl(props: KeyboardDatePickerProps) {
	const { name, fieldProps, ...rest } = props;

	return (
		<Field
			name={name}
			render={fieldRenderProps => <KeyboardDatePickerWrapper {...fieldRenderProps} {...rest} />}
			{...fieldProps}
		/>
	);
}

export default DateControl;
